import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Avatar } from "primereact/avatar";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { classNames } from "primereact/utils";
import { useFormik } from "formik";
import { Handbook_Status, severity } from "../../helper/enum";
import { DataStore } from "aws-amplify";
import { Employee, Handbook, Schools, HandbookAssignee } from "../../models";
import moment from "moment";
import { toast } from "react-toastify";
import FieldWrapper from "../../components/FieldWrapper/FieldWrapper";
import { SendHandbookNotification } from "../../helper/mail";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

const processOptions = (options = [], nameKey = "", codeKey = "", schoolName = "") => {
  if (options.length <= 0) return [];
  return options.map(option => ({ ...option, name: option[nameKey], code: option[codeKey], school_name: schoolName }));
};

const emplyeeNameTemplate = record => {
  return (
    <div className="flex flex-wrap items-center gap-2 ">
      {/* <Avatar image="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50" size="small" shape="circle" /> */}
      {record.employeeName}
    </div>
  );
};

const statusTemplate = record => {
  return <Tag value={Handbook_Status.PENDING} severity={severity[record.status]}></Tag>;
};

const dateTemplate = (record, option) => {
  return record[option.field];
};
function AssignHandbook() {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [removedRecord, setRemovedRecord] = useState(null);
  const [openNewEmployee, setOpenNewEmployee] = useState(false);
  const [NewEmployeeSchool, setNewEmployeeSchool] = useState(null);   
  const [NewEmployeeName, setNewEmployeeName] = useState('');   
  const [NewEmployeeCode, setNewEmployeeCode] = useState('');  
  const [NewEmployeeEmail, setNewEmployeeEmail] = useState('');
  const [state, setState] = useState({
    schoolsOptions: [],
    employeesOptions: null,
    handbooksOptions: [],
    assignees: []
  });

  const setStateData = data => {
    setState(s => ({ ...s, ...data }));
  };
  

  const formik = useFormik({
    initialValues: {
      handbookName: "",
      school: "",
      employee: "",
      dateOfAcknowledgement: ""
    },
    validate: data => {
      let errors = {};
      return errors;
    },
    onSubmit: data => {
      let errors = "";

      if (data?.employee?.length <= 0) {
        errors = "Employee is Required !";
        toast.error("Employee is Required !");
      }

      if (!data?.handbookName?.code) {
        errors = "Handbook Name is Required !";
        toast.error(errors);
      }

      if (!data?.dateOfAcknowledgement) {
        errors = "Date to Acknowledgement is Required";
        toast.error(errors);
      }
      if (!errors) {
        addToAssigneeList(data);

      }
    }
  });
  console.log('formik: ', formik.values.employee);
  const AddNewEmployee = async () => {
    if (formik.values.school === ""||formik.values.school === null) {
      
      toast.error("Please Select School/Department");
      return;
    } else if (NewEmployeeName === null || NewEmployeeName === "") {
      toast.error("Please Enter Employee Name");
      return;
    } else if (NewEmployeeCode === "") {
      toast.error("Please Enter Employee Code");
      return;
    } else if (NewEmployeeEmail === null || NewEmployeeEmail === "") {
      toast.error("Please Enter Employee Email");
      return;
    }

  var AddedNewEmployee = await Promise.all(formik.values.school?.map(item => DataStore.save(new Employee(
    {
        "school_id":item?.code ,
        "employee_name":NewEmployeeName,
        "employee_code":NewEmployeeCode,
        "email":NewEmployeeEmail

    }
  ))))

  if (AddedNewEmployee) {    
    toast.success('Data Added Successfully.');
    try {
      if (!formik?.values?.school?.length) {
        setStateData({
          employeesOptions: []
        });
        return;
      }

      const schools = formik?.values?.school;
      const predicates = schools.map(school => c => c?.school_id.eq(school.code));
      const employeePromises = predicates.map(predicate => DataStore.query(Employee, predicate));

      const employees = await Promise.all(employeePromises);
      const allEmployees = employees.flat();

      setStateData({
        employeesOptions: processOptions(allEmployees, "employee_name", "id", formik.values.school.name)
        
      });
      const newemployeePromises = AddedNewEmployee;    

      const newemployees = await Promise.all(newemployeePromises);
      const newallEmployees = newemployees.flat()
      formik.setFieldValue("employee",processOptions(newallEmployees, "employee_name", "id", formik.values.school.name));

    } catch (error) {
      // Handle error
    }       
      
    //  let obj = {
    //          name: (AddedNewEmployee.employee_name + ' ' + '(' + AddedNewEmployee.employee_code + ')'),
    //          code: AddedNewEmployee.id
    //         }                         

    //  setSelectedEmployee(obj);  
    
                    

    setOpenNewEmployee(false)
    setNewEmployeeSchool(null);
    setNewEmployeeName("");
    setNewEmployeeCode("");
    setNewEmployeeEmail("");
  }
}
  const addToAssigneeList = ({ handbookName, employee }) => {
    
    const assigneeSet = new Set(state.assignees.map(emp => emp.employeeId));
    const allAssignees = employee
      .filter(empData => !assigneeSet.has(empData.code))
      .map(employee => {
        const assignee = {
          handbookName: handbookName.name,
          handbookId: handbookName.code,
          employeeId: employee.code,
          employee_code: employee.employee_code,
          status: Handbook_Status.PENDING,
          employeeName: employee.name,
          email: employee?.email,
          school_name: employee.school_name,
          dateHandbookSent: moment(formik.values.dateOfAcknowledgement).format("MM/DD/YYYY")
        };
        return assignee;
      });

      const newData = [...state.assignees, ...allAssignees]

    setStateData({ assignees: newData.reverse()});
  };

  const getSchools = useCallback(async () => {
    try {
      const schools = await DataStore.query(Schools);
      setStateData({ schoolsOptions: processOptions(schools, "name", "id") });
    } catch (error) { }
  }, []);

  const getHandbooks = useCallback(async () => {
    try {
      const handbooks = await DataStore.query(Handbook);
      setStateData({ handbooksOptions: processOptions(handbooks, "handbook_name", "id") });
    } catch (error) { }
  }, []);

  const onClearAssigneeList = () => {
    setStateData({ assignee: [] });
  };

  const getEmployees = useCallback(async () => {
    try {
      if (!formik?.values?.school?.length) {
        setStateData({
          employeesOptions: []
        });
        return;
      }

      const schools = formik?.values?.school;
      const predicates = schools.map(school => c => c?.school_id.eq(school.code));
      const employeePromises = predicates.map(predicate => DataStore.query(Employee, predicate));

      const employees = await Promise.all(employeePromises);
      const allEmployees = employees.flat();

      setStateData({
        employeesOptions: processOptions(allEmployees, "employee_name", "id", formik.values.school.name)
      });
    } catch (error) {
      // Handle error
    }
  }, [formik.values.school]);

  // const getEmployeest = useCallback(async () => {
  //   try {
  //     if (!formik?.values?.school?.length) return;
  //     const schools = formik?.values?.school;
  //     const predicate = c => c?.school_id.eq(formik.values.school.code);
  //     const employees = await DataStore.query(Employee, predicate);
  //     setStateData({ employeesOptions: processOptions(employees, 'employee_name', 'id', formik.values.school.name) });
  //   } catch (error) {}
  // }, [formik.values.school]);

  const onAssignClick = async () => {
    const emailsToSend = [];
    const assigneeList = state.assignees.map(assignee => {
      emailsToSend.push(assignee.email);
      return {
        handbook_id: assignee.handbookId,
        emp_id: assignee.employeeId,
        status: Handbook_Status.PENDING,
        // acknowledge_date: moment().format("YYYY-MM-DD"),
        due_date: moment(assignee.dateOfAcknowledgement).format("YYYY-MM-DD"),
        created_date: moment(assignee.dateHandbookSent).format("YYYY-MM-DD"),
        created_by: assignee.employeeName
      };
    });

    try {
      let batchOperations = [];
      for (let assignee of assigneeList) {
        batchOperations.push(DataStore.save(new HandbookAssignee(assignee)));
      }
      const resultArray = await Promise.allSettled(batchOperations);
      for (let result of resultArray) {
        if (result.status === "rejected") {
          console.log(result.reason);
          return;
        }
      }
      toast.success("Successfully Saved");
      onClearAssigneeList();
      if (emailsToSend.length > 0) {
        SendHandbookNotification({
          to: emailsToSend,
          subject: "Handbook is available!",
          from: "ganesh@edbrix.com"
        });
      }
      navigate("/employee-handbook");
    } catch (error) {
      console.log(error);
    }
  };

  const cancelDelete = () => {
    setShowConfirmation(false);
  };

  const handleRemove = (record, option) => {
    setShowConfirmation(true);
    setRemovedRecord(option);
  };

  const stateClear = () => {
    formik.setFieldValue("employee", [])
    formik.setFieldValue("school", [])
    formik.setFieldValue("dateOfAcknowledgement", [])
    formik.setFieldValue("handbookName", [])
  }

  const confirmDelete = () => {
    const newArray = [...state.assignees];
    newArray.splice(removedRecord.rowIndex, 1);
    setStateData({ assignees: newArray });
    setShowConfirmation(false);
    setRemovedRecord(null);
    stateClear()
  };

  useEffect(() => {
    getEmployees();
  }, [getEmployees]);

  useEffect(() => {
    getSchools();
    getHandbooks();
  }, [getSchools, getHandbooks]);
  return (
    <>
      <Header />
      <ConfirmDialog
        visible={showConfirmation}
        onHide={() => setShowConfirmation(false)}
        message="Are you sure you want to delete?"
        header="Confirmation"
        icon="pi pi-exclamation-triangle"
        accept={confirmDelete}
        reject={cancelDelete}
      />
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <Card className="mb-2" title="Add Assignee">
          <form onSubmit={formik.handleSubmit} className="p-fluid">
            <div className="flex flex-wrap items-end gap-4">
              <FieldWrapper id="school" label="Name of School or Department">
                <MultiSelect
                  value={formik.values.school}
                  id="school"
                  options={state.schoolsOptions}
                  optionLabel="name"
                  placeholder="Select School"
                  name="school"
                  className="w-full h-11 max-w-[200px] rounded-md border border-[#E4E7EC] pl-5"
                  style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                  onChange={e => {
                    formik.setFieldValue("employee", []);
                    formik.setFieldValue("school", e.value);
                  }}
                />
              </FieldWrapper>
              <FieldWrapper id="employee" label="Name of Employee " required>
                <div className="flex">
                <MultiSelect
                  value={formik.values.employee}
                  options={state.employeesOptions}
                  optionLabel="name"
                  name="employee"
                  id="employee"
                  multiple
                  placeholder="Select Employee"
                  className="w-full max-w-[200px] h-11 rounded-md border border-[#E4E7EC] pl-5"
                  style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                  onChange={e => {
                    formik.setFieldValue("employee", e.value);
                  }}
                />
                <div onClick={(e)=>setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                     {/* <i className='gusd-pluse-circle' style = {{color: "lightgray",fontSize: "20px", margin: "3px",position:"relative", bottom:"6px"}}></i> */}
                    <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content"/>
                    <i className='icon-tooltip gusd-pluse-circle' style = {{color: "lightgray",fontSize: "20px", margin: "3px",position:"relative", bottom:"6px"}}></i>
                 </div>
                 </div>
              </FieldWrapper>
                                    {/* Add New Employee Popup */}
                                  <Dialog
                                        header="Add New Employee" draggable={false} className='add_New_Employee'
                                        visible={openNewEmployee}
                                        style={{ width: "30vw" }}
                                       
                                        onHide={() => {
                                            setOpenNewEmployee(false);
                                      
                                        }}
                                        // footer={footerContentForReqReject}
                                    >
                                        <div className="m-0">

                                        <div className="font-medium text-sm mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                        {/* <FieldWrapper id="school" label="Name of School or Department"> */}
                                            <MultiSelect
                                              value={formik.values.school}
                                              id="school"
                                              options={state.schoolsOptions}
                                              optionLabel="name"
                                              placeholder="Select School"
                                              name="school"
                                              className="w-[100%] h-11 max-w-[560px] rounded-md border border-[#E4E7EC] pl-5"
                                              style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                              onChange={e => {
                                                formik.setFieldValue("employee", []);
                                                formik.setFieldValue("school", e.value);
                                              }}
                                            />
                                          {/* </FieldWrapper> */}
                                           <div className="font-medium text-sm mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeName}
                                                placeholder=""
                                                onChange={e => {setNewEmployeeName(e.target.value)}}
                                                className="w-full"
                                            />
                                            <div className="font-medium text-sm mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeCode}
                                                placeholder=""
                                                onChange={e => {setNewEmployeeCode(e.target.value)}}
                                                className="w-full"
                                            />

                                            <div className="font-medium text-sm mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeEmail}
                                                placeholder=""
                                                onChange={e => {setNewEmployeeEmail(e.target.value)}}
                                                className="w-full"
                                            />
                                        </div>
                                        <div className='flex justify-between gap-2 mt-3'>
                                            <Link  to="" onClick={() => {  setOpenNewEmployee(false); }}
                                                className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                <i class="pi pi-times"></i><span>Cancel</span></Link>

                                            <Link  to=""  onClick={() => {AddNewEmployee()}}                            
                                                className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                <i class="pi pi-check"></i><span>Add</span></Link>

                                        </div>
                                    </Dialog>
              <FieldWrapper id="handbook" label="Name of Hand Book " required>
                <Dropdown
                  value={formik.values.handbookName}
                  options={state.handbooksOptions}
                  optionLabel="name"
                  name="handbookName"
                  id="handbook"
                  placeholder="Select Handbook"
                  className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                  style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                  onChange={e => {
                    formik.setFieldValue("handbookName", e.value);
                  }}
                />
              </FieldWrapper>
                               
              <FieldWrapper id="dateOfAcknowledgement" label="Date to be Acknowledge" showIcon={false} required>
                <Calendar
                  name="dateOfAcknowledgement"
                  placeholder="Date to be Acknowledged"
                  id="dateOfAcknowledgement"
                  minDate={new Date()}
                  value={formik.values.dateOfAcknowledgement}
                  className="w-full h-11 rounded-md border border-[#E4E7EC] "
                  style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                  onChange={e => {
                    formik.setFieldValue("dateOfAcknowledgement", e.value);
                  }}
                />
              </FieldWrapper>
              <button className="inline-flex h-11 items-center justify-center cursor-pointer w-[100px] px-3 py-2 text-sm font-semibold rounded-md shadow-sm bg-[#113699] hover:bg-[#0f296e] text-white">
                Add
              </button>
            </div>
          </form>
        </Card>

        <div className={state.assignees.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
          <DataTable
            value={[...state.assignees]}
            dataKey="employeeId"
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            className="custpaginator custIcons custmBtnTable custTable"
            scrollable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="PrevPageLink FirstPageLink PageLinks NextPageLink CurrentPageReport RowsPerPageDropdown"
            emptyMessage="No Data"
          >
            {/* <Column field="no" sortable header="S. No"></Column> */}
            <Column field="handbookName" sortable header="Handbook Name"></Column>
            <Column field="employee_code" sortable header="Employee Id"></Column>
            <Column field="employeeName" sortable body={emplyeeNameTemplate} header="Employee Name"></Column>
            <Column field="school_name" sortable header="School"></Column>
            <Column field="dateHandbookSent" body={dateTemplate} sortable header="Date to be Acknowledged"></Column>
            <Column field="status" sortable header="Status" body={statusTemplate}></Column>
            <Column

              field="action"
              header="Action"
              // body={(record, option) => {
              //   return <i className="cursor-pointer gusd-delete" onClick={() => { handleRemove(record, option) }} />;
              // }}

              body={(record, option) => {
                return (
                  <div className="flex justify-center w-full gap-2">
                    {
                      <Link
                        to="#"
                        className="py-2 px-2.5"
                        onClick={() => { handleRemove(record, option) }}
                      >
                        <i className="gusd-delete text-[17px] text-[#667085] font-meduim"></i>
                      </Link>
                    }
                  </div>
                );
              }}


            ></Column>
          </DataTable>
          <div className="flex justify-end w-full gap-2 mt-3">
            <Link
              to="/employee-handbook"
              className=" py-2 px-5 transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] text-[#344054]"
            >
              Cancel
            </Link>
            <button
              onClick={onAssignClick}
              className="inline-flex h-11 items-center justify-center cursor-pointer w-[100px] px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-[#113699] hover:bg-[#0f296e] text-white"
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssignHandbook;
